import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { Button } from 'primereact/button';
import StampaTab from './StampaDokumentacijeTabs/StampaTab';
import UnosTab from './StampaDokumentacijeTabs/UnosTab';

/* Tok je dvodelan, zato dva podtaba:
   ŠTAMPA — dokument se generiše iz šablona firme, zavodi i štampa;
   UNOS   — pošto se potpiše i skenira, primerak se kači uz zavedeni dokument. */
const StampaDokumentacijeHome = () => {
  const { t } = useTranslation();

  const [changeView, setChangeView] = useState(1);
  const activeClass = 'activeButton';

  return (
    <div style={{ marginTop: '1%' }}>
      <Button id={changeView == 1 && activeClass} label={t('stampaDok.tabStampa')}
        className="mt-3 zaposleniShift adminTab" onClick={() => { setChangeView(1) }} />
      <Button id={changeView == 2 && activeClass} label={t('stampaDok.tabUnos')}
        className="mt-3 zaposleniShift adminTab" onClick={() => { setChangeView(2) }} />

      {changeView == 1 && <StampaTab />}
      {changeView == 2 && <UnosTab />}
    </div>
  )
}

export default StampaDokumentacijeHome;
